import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { EsShipmentDetailsFormDesktopComponent } from '../es-shipment-details-form-desktop/es-shipment-details-form-desktop.component';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityModel } from '@data-layer/models/entities';
import { CompaniesService } from '@services/companies.service';
import { CompanyModel } from '@data-layer/models/companies';
import { enumEntrySummarySubmissionType } from '@data-layer/enums/entry-summaries';
import { isEqual } from 'lodash-es';

@Component({
  selector: 'es-shipment-details-desktop',
  template: `
    <p class="almost-there">{{ 'LABELS.ALMOST_DONE_ES' | translate }}</p>

    <desktop-entity-card
      [entity]="importer"
      [entityCode]="enumEntityModelCode.IMPORTER"
      [isImporterFromCompany]="isImporterFromCompany"
      [descriptionText]="'LABELS.DETAILS_IMPORTER_ES_HINT' | translate"
      (edit)="editImporter.emit({ id: $event, entityType: enumEntityModelCode.IMPORTER })"
      (useParent)="useParent.emit()"
      (useDifferent)="editImporter.emit({ id: importer?.id, entityType: enumEntityModelCode.IMPORTER })"
    ></desktop-entity-card>

    <desktop-entry-summary-card cardTitle="LABELS.SHIPMENT_TYPE">
      <ng-container body>
        <es-shipment-details-form-desktop
          [entrySummary]="entrySummary"
          [company]="company"
          [formGroup]="formGroup"
        ></es-shipment-details-form-desktop>
      </ng-container>
    </desktop-entry-summary-card>

    <desktop-entry-summary-card *ngIf="isShowDutiesPaymentType" cardTitle="LABELS.DUTIES_PAYMENT_TYPE">
      <ng-container body>
        <es-shipment-duties-payment-form-desktop
          [entrySummary]="entrySummary"
          [formGroup]="formGroup"
        ></es-shipment-duties-payment-form-desktop>
      </ng-container>
    </desktop-entry-summary-card>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./es-shipment-details-desktop.component.scss'],
})
export class EsShipmentDetailsDesktopComponent implements OnInit, OnChanges {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public formGroup: UntypedFormGroup;

  @Output() public editImporter: EventEmitter<{ id: number; entityType: enumEntityModelCode }> = new EventEmitter<{
    id: number;
    entityType: enumEntityModelCode;
  }>();
  @Output() public useParent: EventEmitter<void> = new EventEmitter<void>();
  @Output() public useDifferent: EventEmitter<enumEntityModelCode> = new EventEmitter<enumEntityModelCode>();

  @ViewChild(EsShipmentDetailsFormDesktopComponent, { static: false })
  public esShipmentDetailsFormDesktopComponent: EsShipmentDetailsFormDesktopComponent;

  public enumEntityModelCode = enumEntityModelCode;

  public importer: EntityModel;
  public company: CompanyModel;

  constructor(private companiesService: CompaniesService) {}

  public ngOnInit(): void {
    this.loadData();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.entrySummary) {
      this.loadData();
    }
  }

  public loadData(): void {
    this.company = this.companiesService.getCompany();
    this.importer = this.entrySummary.importer;
  }

  public saveBonds(): void {
    this.esShipmentDetailsFormDesktopComponent.onSubmit();
  }

  public get isImporterFromCompany(): boolean {
    const company = this.company;
    const savedEntity = this.importer;

    if (!company || !savedEntity) {
      return false;
    }

    return (
      company.identifier === savedEntity.entityIdentifier &&
      company.identifierQualifier === savedEntity.entityIdentifierQualifier &&
      company.businessName === savedEntity.name &&
      isEqual(this.company?.address, savedEntity?.address)
    );
  }

  public get isShowDutiesPaymentType(): boolean {
    return this.entrySummary.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED && !this.isHasActiveACH;
  }

  public get isHasActiveACH(): boolean {
    return this.companiesService.isHasActiveACH;
  }
}
